import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { getRollData } from "@/api/dataAll/rollingData";
import { serchSelect, tabulation, gmToolNewPage } from "@/mixins/index";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "rollingData",
  mixins: [serchSelect, tabulation, gmToolNewPage],
  data: function data() {
    return {
      currentPage: 1,
      tableData: [],
      paramsData: {
        kind: "1" // page: 1,
        // page_size: 10

      },
      tableColumn: [{
        label: this.$t('dateDotDate'),
        prop: "date",
        isfixed: true,
        classname: "font-bold",
        tabText: "2020-01-01"
      }, {
        label: this.$t('serverName'),
        prop: "serverName",
        tabText: "400001"
      }, {
        label: this.$t('serverCreateRoleTotal'),
        prop: "createRoleCount",
        tabText: "服务器创角总数",
        desc: this.$t('serverCreateRoleTotal')
      }, {
        label: this.$t('serverRollCreateRoleTotal'),
        prop: "rollCreateRoleCount",
        tabText: "服务器滚服创角总数",
        desc: this.$t('serverRollCreateRoleTotal')
      }, {
        label: this.$t('serverNoRollCreateRoleTotal'),
        prop: "noRollCreateRoleCount",
        tabText: "服务器非滚服创角数",
        desc: this.$t('serverNoRollCreateRoleTotal')
      }, {
        label: this.$t('serverActiveRoleTotal'),
        prop: "loginRoleCount",
        tabText: "服务器活跃角色总数",
        desc: this.$t('serverActiveRoleTotal')
      }, {
        label: this.$t('serverRollActiveTotal'),
        prop: "rollLoginRoleCount",
        tabText: "服务器滚服活跃总数",
        desc: this.$t('serverRollActiveTotal')
      }, {
        label: this.$t('serverNoRollActiveRoleTotal'),
        prop: "noRollLoginRoleCount",
        tabText: "服务器非滚服活跃角色数",
        desc: this.$t('serverNoRollActiveRoleTotal')
      }, {
        label: this.$t('serverPayTotalPeople'),
        prop: "rechargeCount",
        tabText: "服务器付费总人数",
        desc: this.$t('serverPayTotalPeople')
      }, {
        label: this.$t('serverRollPayTotalPeople'),
        prop: "rollRechargeCount",
        tabText: "服务器滚服付费总人数",
        desc: this.$t('serverRollPayTotalPeople')
      }, {
        label: this.$t('serverNoRollPayPeople'),
        prop: "noRollRechargeCount",
        tabText: "服务器非滚服付费人数",
        desc: this.$t('serverNoRollPayPeople')
      }, {
        label: this.$t('serverPayTotalAmount'),
        prop: "RechargeAmount",
        tabText: "服务器付费总金额",
        desc: this.$t('serverPayTotalAmount')
      }, {
        label: this.$t('serverRollPayTotalAmount'),
        prop: "rollRechargeAmount",
        tabText: "服务器滚服付费总金额",
        desc: this.$t('serverRollPayTotalAmount')
      }, {
        label: this.$t('serverNoRollTotalAmount'),
        prop: "noRollRechargeAmount",
        tabText: "服务器非滚服总金额",
        desc: this.$t('serverNoRollTotalAmount')
      }, {
        label: this.$t('rollPayRate'),
        prop: "RollRechargeRate",
        tabText: "滚服付费率",
        desc: this.$t('rollPayRate')
      }, {
        label: this.$t('newServerPayTotalPeople'),
        prop: "newRechargeCount",
        tabText: "新增服务器付费总人数",
        desc: this.$t('newServerPayTotalPeople')
      }, {
        label: this.$t('newRollPeople'),
        prop: "newRollRechargeCount",
        tabText: "新增滚服人数",
        desc: this.$t('newRollPeople')
      }, {
        label: this.$t('newNoRollPeople'),
        prop: "newNoRollRechargeCount",
        tabText: "新增非滚服人数",
        desc: this.$t('newNoRollPeople')
      }, {
        label: this.$t('newServerPayTotalAmount'),
        prop: "newRechargeAmount",
        tabText: "新增服务器付费总金额",
        desc: this.$t('newServerPayTotalAmount')
      }, {
        label: this.$t('newRollPay'),
        prop: "newRollRechargeAmount",
        tabText: "新增滚服付费",
        desc: this.$t('newRollPay')
      }, {
        label: this.$t('newNoRollPay'),
        prop: "newNoRollRechargeAmount",
        tabText: "新增非滚服付费",
        desc: this.$t('newNoRollPay')
      }]
    };
  },
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  methods: {
    selectAll: function selectAll() {
      var _this = this;

      this.searchData.server_id = [];

      if (this.checked) {
        this.serverListYJ.map(function (item) {
          _this.searchData.server_id.push(item.serverID);
        });
      } else {
        this.searchData.server_id = [];
      }
    },
    selecRotAll: function selecRotAll() {
      var _this2 = this;

      this.searchData.server_id = [];

      if (this.checked) {
        this.serverLists.map(function (item) {
          _this2.searchData.server_id.push(item.serverID);
        });
      } else {
        this.searchData.server_id = [];
      }
    },
    getServerList: function getServerList() {
      var _this3 = this;

      var env_id = this.propsData ? this.propsData.env_id : this.searchData.env_id;
      yjServerList({
        server_channel: this.server_channel,
        show_test: this.show_test,
        env_id: env_id
      }).then(function (res) {
        if (res.code == 200) {
          _this3.serverListYJ = res.data;
        }
      });
    },
    severlistChange: function severlistChange(e) {
      var _this4 = this;

      this.serverLists = [];
      this.searchData.server_id = "";

      if (e) {
        hdServerList({
          is_prod: this.searchData.is_prod
        }).then(function (res) {
          if (res.status == 200) {
            _this4.serverLists = res.data;
          }
        });
      }
    },
    getList: function getList(e) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this5.searchData.server_id) {
                  _context2.next = 3;
                  break;
                }

                _this5.$message.error(_this5.$t('pleaseSelectServer'));

                return _context2.abrupt("return");

              case 3:
                if (_this5.value2.length > 0) {
                  _this5.searchData.starttime = _this5.value2[0];
                  _this5.searchData.endtime = _this5.value2[1];
                } // this.paramsData.page = e;


                _this5.searchData.kind = "1";
                _this5.reqLoading = true;
                _this5.tableData = [];
                _this5.searchData.currency_info = _this5.defaultData().currency_info;
                getRollData(_this5.searchData).then(function (res) {
                  if (res.status == 200) {
                    console.log("res==", res);
                    var data = res.data;
                    var list = _this5.rawData.game_mark.indexOf('royalpirates') > -1 ? _this5.serverLists : _this5.serverListYJ;

                    var _loop = function _loop(key) {
                      var newKey = key.split(":");
                      var server_name = '';
                      var foundData = list.find(function (b) {
                        return b.serverID == newKey[1];
                      });
                      server_name = foundData ? foundData.serverName : '/';

                      _this5.tableData.push(_objectSpread({
                        date: newKey[0],
                        serverName: server_name
                      }, data[key]));
                    };

                    for (var key in data) {
                      _loop(key);
                    }

                    _this5.tableData.forEach(function (item) {
                      item.RechargeAmount = item.RechargeAmount / 100;
                      item.rollRechargeAmount = item.rollRechargeAmount / 100;
                      item.noRollRechargeAmount = item.noRollRechargeAmount / 100;
                      item.RollRechargeRate = item.rechargeCount == 0 ? 0 : (item.rollRechargeCount / item.rechargeCount * 100).toFixed(2) + '%';
                      item.newRechargeAmount = item.newRechargeAmount / 100;
                      item.newRollRechargeAmount = item.newRollRechargeAmount / 100;
                      item.newNoRollRechargeAmount = item.newNoRollRechargeAmount / 100;
                    });
                  }
                }).finally(function () {
                  _this5.reqLoading = false;
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // currentChaneg(e) {
    //   this.paramsData.page = e
    //   this.getList()
    // },
    exportdata: function exportdata() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var list;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                list = [];

                _this6.$export.excel({
                  columns: _this6.tableColumn,
                  data: JSON.parse(JSON.stringify(_this6.tableData)),
                  title: _this6.$route.meta.title
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};